import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';

//Actions
import * as appActions from '../actions/appActions';
import * as freightTypesActions from '../actions/freightTypesActions';

class ManageFreightTypes extends React.Component {

    constructor(props) {
        super(props);
        this.props.actions.getFreightTypes();
    }

    render() {
        const { isLoggedIn, isSuperUser, isAdmin } = this.props.userState;
        if (!(isLoggedIn && (isSuperUser || isAdmin))) return false;
        let { data, freightTypes, actions } = this.props;
        freightTypes = freightTypes.data;
        return (
            <div>
                <h1>Freights</h1>
                <div className='manage-freight-types-container'>
                { freightTypes && freightTypes.length ?
                freightTypes.map( item =>
                 <div
                     key={'freightType_'+item.id}
                     className='manage-freight-types-row'>

                     <div className='title'>{ item.title}</div>
                     <div className='description'>{ item.description }</div>
                     <div
                         onClick={actions.showFreightTypePopup.bind(this, 'update', item)}
                         className='edit'>edit</div>
                     <div
                         onClick={actions.deleteFreightType.bind(this, item.id, item.title)}
                         className='delete'>delete</div>
                 </div>
                ) : null }
                <div
                    onClick={actions.showFreightTypePopup.bind(this, 'create')}
                    className='manage-freight-types-create-row'>Create new freight</div>
                </div>
            </div>
        )
    }

};


export default connect(
    state => ({
        userState: state.user,
        freightTypes: state.freightTypes
    }),
    dispatch => ({
        actions: bindActionCreators({...appActions, ...freightTypesActions}, dispatch)
    })
)(ManageFreightTypes);



// WEBPACK FOOTER //
// ./source/screens/manageFreightTypes.js